export default __webpack_public_path__ + "static/media/shibapuppromo.96b8c6b0.mp4";